"use client";

import React from "react";
import { motion } from "framer-motion";

const AboutSection = () => {
  return (
    <section className="relative py-28 bg-white w-full overflow-hidden">
      <div className="w-full mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          
          {/* TEXT — LEFT */}
          <motion.div
            className="space-y-8 px-6 sm:px-10 md:px-16 lg:pl-24 lg:pr-12"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-neutral-900">
              THE STUDIO
            </h2>

            <div className="h-px w-24 bg-neutral-300" />

            <div className="text-lg leading-relaxed text-neutral-700 space-y-6 max-w-xl">
              <p>
                STUDIO SHARAN is an architectural practice driven by clarity,
                restraint, and contextual intelligence. We believe architecture
                should emerge from its place—climate, material, structure, and
                human occupation.
              </p>
              <p>
                Our work focuses on crafting spaces that are calm, precise, and
                enduring. Through careful detailing, honest materials, and
                rigorous spatial thinking, we pursue architecture that ages
                gracefully and performs meaningfully over time.
              </p>
              <p>
                The studio operates across residential, workplace, and
                research-led projects, maintaining a strong engagement with
                construction processes and material experimentation.
              </p>
            </div>
          </motion.div>

          {/* IMAGE — RIGHT */}
          <motion.div
            className="
              relative w-full overflow-hidden
              aspect-[3/4] lg:aspect-[16/9]
              pr-0 sm:pr-0 md:pr-0 lg:pr-24
            "
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          >
            <img
              src={process.env.PUBLIC_URL + "/images/projects/moira-goa/thumb.webp"}
              alt="Studio Sharan Architecture"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/5" />
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;
